import {
  includeHeaderFieldAndIndent,
  totalReducer
} from '../utility';

const GetHazardTooltip = ({ hazards, title, filterKey, filterFunc = filter => filter, valueKey = null }) => hazards && hazards.some(({ [filterKey]: filter }) => filterFunc(filter)) && ({
  title,
  fields: hazards
    .filter(({ [filterKey]: filter }) => filterFunc(filter))
    .map(({ id, categoryName, subCategoryName, [valueKey || filterKey]: value }) => ({
      key: id,
      label: `${categoryName} ${subCategoryName}`,
      value,
    })),
});

export default (hazards, applyHeaderAndIndent) =>
  includeHeaderFieldAndIndent(applyHeaderAndIndent, "Hazards",
    [
      {
        label: 'Majors',
        value: hazards.reduce(totalReducer('majorCount'), 0),
        editable: false,
        tooltip: GetHazardTooltip({ hazards, title: 'Majors', filterKey: 'majorCount' }),
      },
      {
        label: 'Minors',
        value: hazards.reduce(totalReducer('minorCount'), 0),
        editable: false,
        tooltip: GetHazardTooltip({ hazards, title: 'Minors', filterKey: 'minorCount' }),
      },
    ],
  );